import React, { Component } from "react";
import {Button} from "antd";
import {parse} from "qs";
import {isEmpty, isNil} from "lodash";
import FilterBar from "./components/filter-bar/index";
import LogDetailCard from "./components/log-detail-card/index";
import LogInformation from "./components/log-information/index";
import LogListInfiniteScroll from "./components/loglist-infinite-scroll/index";
import TimeMiniMap from "./components/time-minimap/index";
import {convertBriefsToMinimapBriefs, convertBriefsToLoglistInfiniteScrollBriefs} from "../../../common/adapter"
import {NUMBER_OF_LOG_IN_SINGLE_PAGE} from "../../../consts/pagination"
import "./style.scss";
import {LOG_MOVE_DISTANCE} from "./components/loglist-infinite-scroll/consts";
import {fetchNativeDownloadUrlApi, fetchWebDownloadUrlApi} from "../../../common/api";



class LogDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailWidth: LogDetailPage.getDefaultDetailWidth()
    };
  }

  static getDefaultDetailWidth() {
    if (typeof window === "undefined") return 420;
    const vw = window.innerWidth;
    // PC 宽屏：固定 420；更宽的屏幕适当放大；窄屏走堆叠布局，此值会被媒体查询覆盖
    if (vw >= 1400) return 480;
    if (vw >= 1100) return 420;
    return 360;
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.handleSplitterMouseMove);
    document.removeEventListener("mouseup", this.handleSplitterMouseUp);
  }

  handleSplitterMouseDown = (e) => {
    e.preventDefault();
    this.startX = e.clientX;
    this.startWidth = this.state.detailWidth;
    document.addEventListener("mousemove", this.handleSplitterMouseMove);
    document.addEventListener("mouseup", this.handleSplitterMouseUp);
    document.body.style.userSelect = "none";
    document.body.style.cursor = "col-resize";
  };

  handleSplitterMouseMove = (e) => {
    const deltaX = e.clientX - this.startX;
    const newWidth = Math.max(350, Math.min(1200, this.startWidth - deltaX));
    this.setState({ detailWidth: newWidth });
  };

  handleSplitterMouseUp = () => {
    document.removeEventListener("mousemove", this.handleSplitterMouseMove);
    document.removeEventListener("mouseup", this.handleSplitterMouseUp);
    document.body.style.userSelect = "";
    document.body.style.cursor = "";
  };

  render() {
    const {
      briefs,
      taskDetails,
      highlightStartIndex,
      highlightEndIndex,
      logInfo,
      logTypesInTask,
      filterConditions,
      focusLogId,
      logDetail,
      updateFilterConditions,
      updateFocusLogId,
      updateHighLightIndex,
      updateSorted,
      fetchTaskDetail,
      type,
      sorted
    } = this.props;

    const { upHasMore, downHasMore } = this._calculateUpHasMoreAndDownHasMore({briefs: briefs, startLogIndex: highlightStartIndex});

    return (
      <div className="logdetail-container">
        <div className="header">
          <Button icon="left" onClick={this.handleBackToListButtonClicked}>返回列表</Button>
          <LogInformation logInfo={logInfo} type={type}/>
          <Button icon="download" onClick={this.handleLogDownloadButtonClicked}>日志文件下载</Button>
        </div>
        <div className="content">
          <FilterBar
            type={type}
            filterConditions={filterConditions}
            logTypesInTask={logTypesInTask}
            onFilterConditionChanged={updateFilterConditions}
            rollingListManually={this.rollingListManually}
            onSortedChanged={updateSorted}
            sorted={sorted}
          />
          <div className="detail-container">
            {(briefs && convertBriefsToMinimapBriefs(briefs, type).length > 50) &&
              <TimeMiniMap
                type={type}
                timelineMarginTop={20}
                timelineMarginBottom={20}
                timelineWidth={30}
                timelineLeftOffset={8}
                data={convertBriefsToMinimapBriefs(briefs, type)}
                startIndex={highlightStartIndex}
                endIndex={highlightEndIndex}
                updateFocusLogId={updateFocusLogId}
                updateHighLightIndex={updateHighLightIndex}
                rollingListManually={this.rollingListManually}
              />
            }
            <LogListInfiniteScroll
              type={type}
              briefs={convertBriefsToLoglistInfiniteScrollBriefs(briefs, type)}
              upHasMore={upHasMore}
              downHasMore={downHasMore}
              data={taskDetails}
              focusLogId={focusLogId}
              updateHighLightIndex={updateHighLightIndex}
              updateFocusLogId={updateFocusLogId}
              fetchTaskDetail={fetchTaskDetail}
              rollingListManually={this.rollingListManually}
            />
            {focusLogId !== -1 && (
              <div
                className="layout-splitter"
                onMouseDown={this.handleSplitterMouseDown}
              />
            )}
            {focusLogId === -1 ? (
              <div
                className="detail-placeholder"
                style={{ width: this.state.detailWidth, flex: "0 0 " + this.state.detailWidth + "px" }}
              >
                <div className="detail-placeholder-inner">
                  点击左侧任意日志查看详情
                </div>
              </div>
            ) : (
              <LogDetailCard
                type={type}
                focusLogId={focusLogId}
                logDetail={logDetail}
                updateFocusLogId={updateFocusLogId}
                style={{ width: this.state.detailWidth, flex: "0 0 " + this.state.detailWidth + "px" }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  rollingListManually = (logIndex) => {
    const $listScroll = document.querySelector("#infinite-container-inner");
    if ($listScroll) {
      let nextScrollTop = logIndex * LOG_MOVE_DISTANCE - LOG_MOVE_DISTANCE;
      $listScroll.scrollTo(0, nextScrollTop);
    }
  };

  handleBackToListButtonClicked = () => {
    const { type, history, nativeListFilterConditions, webListFilterConditions } = this.props;
    if (type === "native") {
      const { deviceId, platform, beginTime, endTime } = nativeListFilterConditions;
      if (((!isEmpty(deviceId) && !isNil(deviceId)) && !isNil(platform) && !isNil(beginTime) && !isNil(endTime))) {
        history.push(`/native-list?deviceId=${deviceId}&beginTime=${beginTime}&endTime=${endTime}&platform=${platform}`)
      } else {
        history.push("/native-list")
      }
    } else {      
      const { deviceId, beginTime, endTime } = webListFilterConditions;
      if (((!isEmpty(deviceId) && !isNil(deviceId)) && !isNil(beginTime) && !isNil(endTime))) {
        history.push(`/web-list?deviceId=${deviceId}&beginTime=${beginTime}&endTime=${endTime}`)
      } else {
        history.push("/web-list")
      }
    }
  }

  handleLogDownloadButtonClicked = () => {
    if (this.props.location) {
      const {type} = this.props;
      const {tasks} = parse(this.props.location.search, { ignoreQueryPrefix: true });
      let downloadUrlPromise = null;
      if (type === "native") {
        downloadUrlPromise = fetchNativeDownloadUrlApi(tasks)
      } else {
        downloadUrlPromise = fetchWebDownloadUrlApi(tasks)
      }
      downloadUrlPromise.then(data => {
        // replace your own download logic here!
        window.open(`${window.location.origin}${data}`);
      })
    }
    
  };

  _calculateUpHasMoreAndDownHasMore = ({ briefs, startLogIndex }) => {
    let upHasMore = false;
    let downHasMore = false;
    const pageSize = NUMBER_OF_LOG_IN_SINGLE_PAGE;
    const pageNum = Math.ceil(briefs.length / pageSize);
    if (briefs.length > 0) {
      const pageIndex = Math.floor(startLogIndex / pageSize);
      if (pageIndex === 0) {
        upHasMore = false;
        downHasMore = true;
      } else if (pageIndex > 0 && pageIndex < pageNum) {
        upHasMore = true;
        downHasMore = true;
      } else {
        upHasMore = true;
        downHasMore = false;
      }
    }

    return { upHasMore, downHasMore };
  };

}

export default LogDetailPage;
